import { render, staticRenderFns } from "./CorrelationList.vue?vue&type=template&id=7e2460a6&scoped=true"
import script from "./CorrelationList.vue?vue&type=script&lang=ts"
export * from "./CorrelationList.vue?vue&type=script&lang=ts"
import style0 from "./CorrelationList.vue?vue&type=style&index=0&id=7e2460a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2460a6",
  null
  
)

export default component.exports